export default __webpack_public_path__ + "static/media/bidifylogo_movr.6094fa39.png";